<template>
  <!-- <v-overlay app :value="isLoading" transition="fade">
    <v-progress-circular indeterminate size="360" color="primary"
      ><span style="color:white;">{{ quote }}...</span>
    </v-progress-circular>
  </v-overlay>-->
  <div>
    <v-snackbar
      v-for="(notification, i) in notifications"
      v-model="notification.show"
      top
      outline
      :key="i"
      :timeout="6000"
    >
      {{ notification.text }}
      <v-btn color="red" text @click="closeNotification(notification)">{{ $t("Remove") }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import { messaging } from "@/firebase/firestore.js";
// import NotifyToken from "@/model/notifyToken";

import Activity from "@/model/activity";
export default {
  data() {
    return {
      text: "",
      snackbar: true,
      notShowed: false,
      notifications: [],
      oldActivities: []
    };
  },

  computed: {
    activities() {
      return this.$store.state.activities.filter(function(el) {
        return el.dismissed != true;
      });
    }
  },
  methods: {
    closeNotification(notification) {
      notification.activity.dismissed = true;
      notification.activity.save();
      notification.show = false;
    }
    // getMessagingToken() {
    //   messaging
    //     .getToken()
    //     .then(async token => {
    //       if (token) {
    //         const currentMessageToken = window.localStorage.getItem(
    //           "messagingToken"
    //         );
    //         console.log("token will be updated", currentMessageToken != token);
    //         if (currentMessageToken != token) {
    //           await this.saveToken(token);
    //         }
    //       } else {
    //         console.log(
    //           "No Instance ID token available. Request permission to generate one."
    //         );
    //         this.notificationsPermisionRequest();
    //       }
    //     })
    //     .catch(function(err) {
    //       console.log("An error occurred while retrieving token. ", err);
    //     });
    // },
    // notificationsPermisionRequest() {
    //   messaging
    //     .requestPermission()
    //     .then(() => {
    //       this.getMessagingToken();
    //     })
    //     .catch(err => {
    //       console.log("Unable to get permission to notify.", err);
    //     });
    // },
    // listenTokenRefresh() {
    //   const currentMessageToken = window.localStorage.getItem("messagingToken");
    //   console.log("currentMessageToken", currentMessageToken);
    //   if (currentMessageToken) {
    //     messaging.onTokenRefresh(function() {
    //       messaging
    //         .getToken()
    //         .then(function(token) {
    //           this.saveToken(token);
    //         })
    //         .catch(function(err) {
    //           console.log("Unable to retrieve refreshed token ", err);
    //         });
    //     });
    //   }
    // },
    // saveToken(token) {
    //   if (this.$store.getters.notifyToken != token) {
    //     new NotifyToken({ id: this.$store.getters.notifyToken }).delete();
    //   }
    //   this.$store.commit("set", {
    //     varName: "notifyToken",
    //     value: token
    //   });
    //   new NotifyToken({ id: token }).save();
    // }
  },
  created() {
    // this.notificationsPermisionRequest();
    // messaging.onMessage(payload => {
    //   console.log("Message received. ", payload);
    //   // ...
    // });
  },
  watch: {
    activities() {
      let activitiesObj = this.activities.map(activity =>
        Activity.fromMap(activity)
      );
      if (this.notShowed) {
        let activities = activitiesObj.filter(
          x => !this.oldActivities.map(activity => activity.id).includes(x.id)
        );
        if (activities.length > 0) {
          let src = require("@/assets/bell.mp3");
          let audio = new Audio(src);
          audio.play();
        }
        activities.forEach(activity => {
          if (activity.type == "callwaiter") {
            let location = this.$store.getters.locations.filter(
              location => location.id === activity.location
            )[0];
            this.notifications.push({
              activity: activity,
              show: true,
              text: this.$t("Waiter to {locationName}", {
                locationName: location.name
              })
            });
          }
          if (activity.type == "readMenu") {
            let location = this.$store.getters.locations.filter(
              location => location.id === activity.location
            )[0];
            this.notifications.push({
              activity: activity,
              show: true,
              text: this.$t("New client at {locationName}", {
                locationName: location.name
              })
            });
          }
          if (activity.type == "newOrder") {
            let location = this.$store.getters.locations.filter(
              location => location.id === activity.location
            )[0];
            this.notifications.push({
              activity: activity,
              show: true,
              text: this.$t("New order at {locationName}", {
                locationName: location.name
              })
            });
          }
          if (activity.type == "cash") {
            let location = this.$store.getters.locations.filter(
              location => location.id === activity.location
            )[0];
            this.notifications.push({
              activity: activity,
              show: true,
              text: this.$t("Cash pay at {locationName}", {
                locationName: location.name
              })
            });
          }
          if (activity.type == "creditCard") {
            let location = this.$store.getters.locations.filter(
              location => location.id === activity.location
            )[0];
            this.notifications.push({
              activity: activity,
              show: true,
              text: this.$t("Credit card pay at {locationName}", {
                locationName: location.name
              })
            });
          }
        });
      }
      this.oldActivities = [...activitiesObj];
      if (this.activities.length > 0) this.notShowed = true;
    }
  }
};
</script>

<style></style>
